import { useTranslation } from 'next-i18next/pages';
import Image from 'next/image';

import { ReactComponent as CheckCircle } from '@pflegia/ui/icons/check-circle.svg';
import { getButtonClassName } from '@pflegia/ui/shared/button';
import ContainerSection from '@pflegia/ui/shared/container-section';

import pointingSidewaysImage from '@public/assets/female-pointing-left-with-bubble.png';
import pointingUpImage from '@public/assets/female-pointing-up-with-bubble.png';

import { JOBS_SEARCH_ANCHOR_ID } from './JobsSearchCard';

const SignUpCta: React.FC = () => {
  const { t } = useTranslation('jobBoard', { keyPrefix: 'jobsPageHub.signUpCta' });
  const benefits = t('benefits', { returnObjects: true }) as string[];

  return (
    <ContainerSection className='mt-24'>
      <div className='bg-extended-jobs-background flex flex-col items-center gap-6 overflow-hidden rounded-2xl px-6 pt-6 md:rounded-3xl lg:flex-row lg:gap-10 lg:pt-0'>
        <Image
          alt=''
          className='hidden w-70 shrink-0 -scale-x-100 object-contain pt-5 lg:block'
          height={280}
          src={pointingSidewaysImage}
          width={280}
        />

        <div className='flex w-full flex-col items-start gap-4'>
          <h2 className='text-default text-2xl md:text-2xl'>{t('title')}</h2>

          <ul className='flex flex-col gap-3 lg:flex-row lg:gap-6'>
            {benefits.map(benefit => (
              <li className='text-default flex items-start gap-2' key={benefit}>
                <CheckCircle className='text-primary mt-0.5 h-5 w-5 shrink-0' />
                {benefit}
              </li>
            ))}
          </ul>

          <a
            className={getButtonClassName('primary', 'w-full rounded-full px-6 py-3 text-center font-light text-white lg:w-fit')}
            href={`#${JOBS_SEARCH_ANCHOR_ID}`}>
            {t('cta')}
          </a>
        </div>

        <Image alt='' className='w-64 -scale-x-100 object-contain lg:hidden' height={280} src={pointingUpImage} width={280} />
      </div>
    </ContainerSection>
  );
};

export default SignUpCta;
